/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CustomsAdministrationReportReq } from '../models/customs-administration-report-req';
import { CustomsAdministrationReportResp } from '../models/customs-administration-report-resp';
import { CustomsInvoiceReportReq } from '../models/customs-invoice-report-req';
import { CustomsInvoiceReportResp } from '../models/customs-invoice-report-resp';
import { OrderReportReq } from '../models/order-report-req';
import { OrderReportResp } from '../models/order-report-resp';
import { ProductDatasheetReq } from '../models/product-datasheet-req';
import { ProductDatasheetResp } from '../models/product-datasheet-resp';

@Injectable({
  providedIn: 'root',
})
export class OrderReportService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation productDatasheet
   */
  static readonly ProductDatasheetPath = '/order-report/product-datasheet';

  /**
   * Get product report from order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productDatasheet()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productDatasheet$Response(params: {
    body: ProductDatasheetReq
  }): Observable<StrictHttpResponse<ProductDatasheetResp>> {

    const rb = new RequestBuilder(this.rootUrl, OrderReportService.ProductDatasheetPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductDatasheetResp>;
      })
    );
  }

  /**
   * Get product report from order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productDatasheet$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productDatasheet(params: {
    body: ProductDatasheetReq
  }): Observable<ProductDatasheetResp> {

    return this.productDatasheet$Response(params).pipe(
      map((r: StrictHttpResponse<ProductDatasheetResp>) => r.body as ProductDatasheetResp)
    );
  }

  /**
   * Path part for operation customsInvoiceReport
   */
  static readonly CustomsInvoiceReportPath = '/order-report/customs-invoice-report';

  /**
   * Get customs invoice report from order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customsInvoiceReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customsInvoiceReport$Response(params: {
    body: CustomsInvoiceReportReq
  }): Observable<StrictHttpResponse<CustomsInvoiceReportResp>> {

    const rb = new RequestBuilder(this.rootUrl, OrderReportService.CustomsInvoiceReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomsInvoiceReportResp>;
      })
    );
  }

  /**
   * Get customs invoice report from order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `customsInvoiceReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customsInvoiceReport(params: {
    body: CustomsInvoiceReportReq
  }): Observable<CustomsInvoiceReportResp> {

    return this.customsInvoiceReport$Response(params).pipe(
      map((r: StrictHttpResponse<CustomsInvoiceReportResp>) => r.body as CustomsInvoiceReportResp)
    );
  }

  /**
   * Path part for operation customsAdministrationReport
   */
  static readonly CustomsAdministrationReportPath = '/order-report/customs-administration-report';

  /**
   * Get customs invoice administration report from order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customsAdministrationReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customsAdministrationReport$Response(params: {
    body: CustomsAdministrationReportReq
  }): Observable<StrictHttpResponse<CustomsAdministrationReportResp>> {

    const rb = new RequestBuilder(this.rootUrl, OrderReportService.CustomsAdministrationReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomsAdministrationReportResp>;
      })
    );
  }

  /**
   * Get customs invoice administration report from order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `customsAdministrationReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customsAdministrationReport(params: {
    body: CustomsAdministrationReportReq
  }): Observable<CustomsAdministrationReportResp> {

    return this.customsAdministrationReport$Response(params).pipe(
      map((r: StrictHttpResponse<CustomsAdministrationReportResp>) => r.body as CustomsAdministrationReportResp)
    );
  }

  /**
   * Path part for operation orderReport
   */
  static readonly OrderReportPath = '/order-report/get';

  /**
   * Get order report
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderReport$Response(params: {
    body: OrderReportReq
  }): Observable<StrictHttpResponse<OrderReportResp>> {

    const rb = new RequestBuilder(this.rootUrl, OrderReportService.OrderReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrderReportResp>;
      })
    );
  }

  /**
   * Get order report
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `orderReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderReport(params: {
    body: OrderReportReq
  }): Observable<OrderReportResp> {

    return this.orderReport$Response(params).pipe(
      map((r: StrictHttpResponse<OrderReportResp>) => r.body as OrderReportResp)
    );
  }

}
